import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.trim";
import $ from 'jquery';
import Cookies from 'js-cookie';
import { replaceWithEntity, XMLStr2XMLDoc } from "./CommonFunctions";

/*
 基础类，控制页面执行流程，每个页面都必须引用:
 1.多语言翻译
 Cookie：

 模板页生成的全局变量列表：
 LANG_TYPE：语言类型
 LANG_KEY_ARR：语言文件URL数组
 WEB_BASE：网站View根目录
 RS_IP:认证服务器IP
 RS_PORT:认证服务器端口
 */

var xmlHeader = '<?xml version="1.0" encoding="utf-8" ?>';
var protocolVer = '1.0';
var systemType = 'NVMS-5000';
var emptyRequest = xmlHeader + '<request version="' + protocolVer + '" systemType="' + systemType + '" clientType="WEB"/>';
var requestHeader = xmlHeader + '<request version="' + protocolVer + '" systemType="' + systemType + '" clientType="WEB">';
var serverIp = window.top.location.hostname;
// 页面语言Key
var pageLangKeys = null;
// 公用语言Key
var commLangKeys = [];
var langMap = {
  'en-us': '0x0409',
  'zh-cn': '0x0804'
};

/**
 * 多语言
 */
export var LangCtrl = {
  // 语言包XML文档JQuery对象，第一次使用时加载，全局保存
  languageXMLDoc: null,
  // 是否需要重新加载语言包，当重新选择了语言类型后，需要重新加载语言包
  isNeedLoadLang: true,
  // 改变语言后执行的方法堆栈
  _callBack: {},
  _version: '20141009.00',
  // 根据标签id获取对应语言的标签值
  _L_: function _L_(tagID) {
    LangCtrl.loadLanguageXMLDoc();
    var tagText = tagID;
    var tag = $('response>content>langItems>item[id="' + replaceWithEntity(tagID) + '"]', LangCtrl.languageXMLDoc);
    if (tag.length > 0) {
      tagText = $(tag[0]).text();
    }
    return tagText;
  },
  // 初始化语言控件
  _initLangCtrl: function _initLangCtrl(langTypeList) {
    $.ajax({
      type: 'POST',
      async: false,
      url: '/service/Common/getSupportLangList',
      success: function success(resultObj) {
        var result = XMLStr2XMLDoc(resultObj.resultXml);
        if ($('response>status', result).text() === 'success') {
          var langId = Cookies('lang_id');
          if (!langId) {
            var devLangId = $('response>content>currentLangType', result).text();
            langId = langMap[(navigator.userLanguage || navigator.language).toLowerCase()];
            if (!langId) {
              langId = devLangId;
            }
            if ($("response>content>item[id='" + langId + "']", result).size() === 0) {
              langId = devLangId;
            }
            var langType = 'en-us';
            $.each(langMap, function (key, value) {
              if (value.toLowerCase() === langId) {
                langType = key;
                return;
              }
            });
            Cookies('lang_type', langType, {
              expires: 36500
            });
            Cookies('lang_id', langId, {
              expires: 36500
            });
          }
          langTypeList.empty();
          $('response>content>item', result).each(function (index, element) {
            var $this = $(this);
            var langId = $this.attr('id');
            var langName = $this.text();
            var langtype = 'en-us';
            $.each(langMap, function (key, value) {
              if (value.toLowerCase() === langId) {
                langtype = key;
                return false;
              }
            });
            langTypeList.append('<div class="item" langtype="' + langtype + '" langId="' + langId + '">' + langName + '</div>');
          });
          $('#langTypeList>.item:last').addClass('last');
          var langId = Cookies('lang_id');
          $('#langType').click(function (event) {
            if (event.stopPropagation) {
              event.stopPropagation();
            }
            $('#calendarTypeList').hide();
            $('#langTypeList')[$('#langTypeList').is(':visible') ? 'hide' : 'show']();
          });
          $('#langTypeList>.item').each(function (index, element) {
            var $this = $(this);
            if ($this.attr('langId') === langId) {
              $('#langTypeSel').html($this.html());
              $this.addClass('selected');
            } else {
              $this.removeClass('selected');
            }
          });
          $('#langTypeList>.item').click(function (event) {
            if (event.stopPropagation) {
              event.stopPropagation();
            }
            var $this = $(this);
            $('#langTypeList').hide();
            if ($this.hasClass('selected')) {
              return;
            }
            $('#langTypeSel').html($this.html());
            LangCtrl.changLang($this.attr('langtype'), $this.attr('langId'));
          });
          var defaultCalendarType = 'Gregorian';
          Cookies('calendarType', defaultCalendarType);
          $(document).click(function (event) {
            $('#langTypeList').hide();
          });
          LangCtrl.translate();
        } else {
          $('body').html('');
        }
      }
    });
  },
  // 加载语言XML文档
  loadLanguageXMLDoc: function loadLanguageXMLDoc() {
    if (!LangCtrl.languageXMLDoc || LangCtrl.isNeedLoadLang) {
      var langKeys = commLangKeys;
      if (pageLangKeys) {
        langKeys = langKeys.concat(pageLangKeys);
      }
      var langType = LangCtrl.getLang();
      // 获取当前页面语言key
      var items = [];
      $.each(langKeys, function (i, elem) {
        items[i] = elem;
      });
      try {
        $.ajax({
          type: 'POST',
          async: false,
          url: '/service/Common/getLangContent',
          data: {
            langType: langType,
            items: items
          },
          success: function success(resultObj) {
            var result = XMLStr2XMLDoc(resultObj.resultXml);
            if ($('response>status', result).text() === 'success') {
              LangCtrl.languageXMLDoc = result;
              var langId = $.trim($('response>content>langType', result).text());
              var langType = 'en-us';
              if (langId === '0x0804') {
                langType = 'zh-cn';
              }
              Cookies('lang_type', langType, {
                expires: 36500
              });
              Cookies('lang_id', langId, {
                expires: 36500
              });
            } else {
              // $(document.body).html('')
              // LangCtrl.languageXMLDoc = null
            }
          },
          error: function error() {
            // $(document.body).html('')
          }
        });
      } catch (ex) {
        // $(document.body).html('')
      }
      LangCtrl.isNeedLoadLang = false;
    }
  },
  // 改变语言
  changLang: function changLang(lang, langId, callback) {
    Cookies('lang_type', lang, {
      expires: 36500
    });
    Cookies('lang_id', langId, {
      expires: 36500
    });
    LangCtrl.isNeedLoadLang = true;
    window.top.location.reload();
  },
  setLang: function setLang(drp) {
    var type = Cookies('lang_type');
    if (type) drp.val(type);
  },
  getLang: function getLang() {
    var langType = Cookies('lang_type');
    var langId = Cookies('lang_id');
    if (!langType) {
      try {
        $.ajax({
          type: 'POST',
          async: false,
          url: '/service/Common/getLangContent',
          data: {
            langType: langId,
            items: []
          },
          success: function success(resultObj) {
            var result = XMLStr2XMLDoc(resultObj.resultXml);
            if ($('response>status', result).text() === 'success') {
              langId = $.trim($('response>content>langType', result).text());
              langType = 'en-us';
              if (langId === '0x0804') {
                langType = 'zh-cn';
              }
            } else if ($('response>status', result).text() === 'fail') {
              langType = 'zh-cn';
              langId = '0x0804';
            }
            Cookies('lang_type', langType, {
              expires: 36500
            });
            Cookies('lang_id', langId, {
              expires: 36500
            });
          }
        });
      } catch (ex) {
        Cookies('lang_type', 'zh-cn', {
          expires: 36500
        });
        Cookies('lang_id', '0x0804', {
          expires: 36500
        });
      }
    }
    return langId;
  },
  // 添加改变语言后执行的方法
  addCallBack: function addCallBack(key, fun) {
    if (key in LangCtrl._callBack) {} else {
      LangCtrl._callBack[key] = fun;
    }
  },
  // 翻译页面
  translate: function translate(context) {
    var tranObj = context ? $('[lc]', context) : $('[lc]');
    tranObj.each(function (index, domEle) {
      var $domEle = $(domEle);
      var lcArr = $domEle.attr('lc').split(',');
      for (var i in lcArr) {
        switch (lcArr[i]) {
          case 'html':
            $domEle.html(LangCtrl._L_($domEle.attr('lk')));
            break;
          case 'value':
            $domEle.val(LangCtrl._L_($domEle.attr('lk')));
            break;
          case 'title':
            $domEle.attr('title', LangCtrl._L_($domEle.attr('lk')));
            break;
        }
      }
    });
  }
};